const initialState = {
    template: {
        name: '',
        published: 0,
        filter: "",
        websiteCategory1: "",
        websiteCategory2: "",
        priority: 0,
        productSeriesId: 0,
        groupMetaClassName: "",
        metaClassName: "",
        groupPageLayoutDefault: "",
        createdBy: "",
        lastUpdatedAt: "",
        productTemplateLanguages: [
            {
                language: "",
                groupCode: "",
                groupName: "",
                groupDescription: "",
                groupURL: "",
                groupSEDescription: "",
                groupSETitle: "",
                groupSEKeywords: "",
                groupActive: "",
                groupStartDate: '@ConvertDate("2018-01-01")@',
                groupEndDate: '@ConvertDate("2099-12-31")@',
                groupMappedToReicoSite: "",
                groupMappedToDistributorSite: "",
                code: "",
                name: "",
                description: "",
                active: "",
                startDate: '@ConvertDate("2018-01-01")@',
                endDate: '@ConvertDate("2099-12-31")@',
                manufacturerPartNumber: "[BRPART]",
                gtin: "[BRUPC]",
                imageOverride: "",
                overrideImageBaseName: "",
                swatchImageName: "",
                colorSwatch: "",
                trait1Name: "",
                trait1Value: "",
                trait2Name: "",
                trait2Value: "",
                minimumQty: "1",
                maximumQty: "999999",
                inStockQuantity: "",
                weight: "[BRWEIGHT]",
                showQuoteButton: "@true@",
                showBuyButton: "@false@",
                hidePriceUntilCart: "@false@",
                regularPrice: "",
                salePrice: "",
                msrpPrice: "[BRMSRP]",
                mapPrice: ""
            }
        ]
    },
    updating: false,
    updated: false,
    error: null,
    filter: null,
    formulas: {},
    categories: []
}


export function templateReducer(state = initialState, action) {

    switch (action.type) {

        case "INIT_TEMPLATE":
        case "CREATE_TEMPLATE":
        case "FETCH_TEMPLATE": {
            return { ...state, updating: true, updated: false, error: null, filter: null, formulas: {} }
        }

        case "VALIDATE_SQL": {
            return { ...state, updating: true, updated: false, error: null, filter: null, productGroupCount: null }
        }

        case "GET_PRODUCT_GROUP_COUNT": {
            return { ...state, updating: true, updated: false, error: null, productGroupCount: null }
        }

        case "UPDATE_TEMPLATE":
        case "APPLY_FORMULA":
        case "APPLY_FORMULAS":
        case "FETCH_WEB_CATEGORIES": {
            return { ...state, updating: true, updated: false, error: null }
        }

        case "APPLY_FORMULA_ALL": {
            return { ...state, updating: true, updated: false, error: null, formulas: {} }
        }

        case "VALIDATE_SQL_REJECTED": {
            return { ...state, updating: false, error: "SQL_FAILURE", filter: action.payload.response.data }
        }

        case "GET_PRODUCT_GROUP_COUNT_REJECTED": {
            return { ...state, updating: false, error: "GET_PRODUCT_GROUP_COUNT_FAILURE", productGroupCount:"ERR" }
        }

        case "APPLY_FORMULA_REJECTED":
        case "APPLY_FORMULAS_REJECTED":
        case "APPLY_FORMULA_ALL_REJECTED": {
            return { ...state, updating: false, error: "FORMULA_FAILURE" }
        }

        case "FETCH_WEB_CATEGORIES_REJECTED": {
            return { ...state, updating: false, error: "CATEGORIES_FAILURE" }
        }

        case "CREATE_TEMPLATE_REJECTED":
        case "FETCH_TEMPLATE_REJECTED":
        case "UPDATE_TEMPLATE_REJECTED": {
            return { ...state, updating: false, error: action.payload }
        }

        case "CREATE_TEMPLATE_FULFILLED":
        case "FETCH_TEMPLATE_FULFILLED":
        case "UPDATE_TEMPLATE_FULFILLED": {
            return { ...state, updating: false, updated: true, template: action.payload.data }
        }

        case "VALIDATE_SQL_FULFILLED": {
            return { ...state, updating: false, updated: true, filter: action.payload.data }
        }

        case "GET_PRODUCT_GROUP_COUNT_FULFILLED": {
            return { ...state, updating: false, updated: true, productGroupCount: action.payload.data["productGroupCount"] }
        }

        case "APPLY_FORMULA_FULFILLED": {
            let new_formulas = Object.assign({}, state.formulas)

            new_formulas[action.payload.data.formulaName] = action.payload.data

            return { ...state, updating: false, updated: true, formulas: new_formulas }
        }

        case "APPLY_FORMULAS_FULFILLED": {
            let new_formulas = Object.assign({}, state.formulas)

            action.payload.data.map((val) => {
                new_formulas[val.formulaName] = val;
            });

            return { ...state, updating: false, updated: true, formulas: new_formulas }
        }

        case "APPLY_FORMULA_ALL_FULFILLED": {
            let new_formulas = Object.assign({}, state.formulas)

            action.payload.data.formulaResultsByLanguage.en.map((val) => {
                new_formulas[val.formulaName] = val;
            });

            return { ...state, updating: false, updated: true, formulas: new_formulas }
        }

        case "FETCH_WEB_CATEGORIES_FULFILLED": {
            return { ...state, updating: false, updated: true, categories: action.payload.data }
        }

        case "TEMPLATE_ERROR": {
            return { ...state, error: null }
        }

        default:
            return state
    }
}